import Vue from 'vue'
import Router from 'vue-router'

import { Dashboard, Verfiy } from '@/pages/dashboard';

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: 'result/:docId',
      name: 'result',
      component: Verfiy
    }
    
  ]
})

export default router;  


// WEBPACK FOOTER //
// ./src/router/index.js